import React from 'react'
import { Flex, Box } from 'mds-web-ui'
import { parseDue } from '../utils/dates'
import { getDisplayTime } from '../utils/events'

const Circle = ({ bg, size = 5, tentative }) =>
  tentative ? (
    // just outline
    <Box
      css={{
        borderRadius: 100,
        border: `1px solid ${bg}`,
        height: size,
        width: size,
      }}
    />
  ) : (
    // filled in circle
    <Box bg={bg} css={{ borderRadius: 100, height: size, width: size }} />
  )

const DisplayTime = ({ event, date }) => {
  const displayTime = getDisplayTime(event, date)
  return (
    <Box
      color="var(--text-color)"
      fontSize={displayTime.length === 10 ? '7px' : '10px'} // shrink font size for event end time
      css={{ textTransform: 'uppercase' }}
      width={50}
      aria-hidden={true}
    >
      {displayTime}
    </Box>
  )
}

export const getEventLabel = (event, date) => {
  const displayTime = getDisplayTime(event, date)
  const displayDate = parseDue(date).format('MMMM Do')

  return `${event.summary} ${displayTime} ${displayDate}`
}

const Title = (props) => (
  <Box
    ml={2}
    color="var(--text-color)"
    fontSize={0}
    aria-hidden={true}
    {...props}
  />
)

const Event = ({ event, date }) => {
  const tentative = event.response === 'tentative'
  return (
    <Flex
      my={1}
      alignItems="center"
      role="listitem"
      // we use a label here so we can format the date/time nicely for screen readers
      aria-label={getEventLabel(event, date)}
    >
      <DisplayTime event={event} date={date} />
      <Circle bg={event.calendarData.backgroundColor} tentative={tentative} />
      <Title>{event.summary}</Title>
    </Flex>
  )
}

export default Event
